import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import MultiSelectCheckbox from "../../../ui/molecules/multiSelectCheckbox";
import { ListItem } from "../../../ui/organisms/listItem";
import { PopupForm } from "../../../ui/organisms/popupForm";
import { rolesOptions } from "../../../utils";
import { GetByIdPersonalManagement, resetGetByIdPersonalManagementResourcesStatus, setPMJobs } from "../slice";
import { RequirementPopupAdd } from "./boxPopupRequirement/add";
import { RequirementPopupEdit } from "./boxPopupRequirement/edit";
import { RequirementDTO } from "./dataService/dto";
import { addRequirementDetail, GetAllRequirements, GetRequirementDetailById, resetGetAllRequirementStatus, resetGetRequirementDetailByIdStatus, resetRequirementCreationRequest, resetRequirementDetails, resetRequirementErrors, resetRequirements, resetRequirementUpdateRequest, setReqDetailPersonalManagementId, setRequirementIdToUpdate, setRequirements, setUpdateNorm, setUpdateRequirement, setUpdateSpec } from "./slice";

export function BoxRequirements() {
    const dispatch = useAppDispatch()
    const requirementState = useAppSelector(state => state.PMRequirement)
    const PMState = useAppSelector(state => state.personalManagement)
    const [addPopupShow, setAddPopupShow] = useState<boolean>(false)
    const [editPopupShow, setEditPopupShow] = useState<boolean>(false)
    const [selectedJobs, setSelectedJobs] = useState<{ label: string; value: string }[]>([]);

    useEffect(() => {
        if (PMState.currentPersonalManagementId) {
            dispatch(setReqDetailPersonalManagementId(PMState.currentPersonalManagementId))
            dispatch(GetByIdPersonalManagement(PMState.currentPersonalManagementId!))
        }
    }, [PMState.currentPersonalManagementId])

    useEffect(() => {
        if (PMState.getByIdPersonalManagementResourcesStatus === 'successfully') {
            dispatch(resetGetByIdPersonalManagementResourcesStatus('idle'))

            if (PMState.getByIdPersonalManagementResourcesResponse?.requirementDetailIds) {
                dispatch(resetRequirementDetails())
                for (let index = 0; index < PMState.getByIdPersonalManagementResourcesResponse?.requirementDetailIds.length; index++) {
                    dispatch(GetRequirementDetailById(PMState.getByIdPersonalManagementResourcesResponse?.requirementDetailIds[index].toString()))
                }
            }

            if (PMState.getByIdPersonalManagementResourcesResponse?.jobs) {
                const jobs = PMState.getByIdPersonalManagementResourcesResponse?.jobs
                dispatch(setPMJobs(jobs))
                setSelectedJobs(jobs as any)
            }

        }
    }, [PMState.getByIdPersonalManagementResourcesStatus])

    useEffect(() => {
        if (requirementState.getRequirementDetailByIdStatus === 'successfully' &&
            requirementState.getRequirementDetailByIdResponse !== undefined
        ) {
            dispatch(resetGetRequirementDetailByIdStatus())
            dispatch(addRequirementDetail(requirementState.getRequirementDetailByIdResponse))
        }
    }, [requirementState.getRequirementDetailByIdStatus])

    useEffect(() => {
        dispatch(resetRequirements())
        dispatch(GetAllRequirements())
    }, [])

    useEffect(() => {
        if (requirementState.getAllRequirementsStatus === 'successfully' &&
            requirementState.getAllRequirementsResponse !== undefined
        ) {
            dispatch(resetGetAllRequirementStatus())
            const toSort = [...requirementState.getAllRequirementsResponse]
            toSort.sort((r1, r2) => Number(r1.id) - Number(r2.id))
            dispatch(setRequirements(toSort))
        }
    }, [requirementState.getAllRequirementsStatus])

    const handleOnEdit = (r: RequirementDTO) => {
        dispatch(setUpdateRequirement(r.requirement))
        dispatch(setUpdateSpec(r.spec))
        dispatch(setUpdateNorm(r.norm))
        dispatch(setRequirementIdToUpdate(r.id))
        setEditPopupShow(true)
    }

    return (
        <div className="w-full p-6">
            <div className="w-full mb-4 rounded-xl border border-neutral-200 bg-white p-4 shadow-sm">
                <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
                    <div className="w-full lg:max-w-[75%]">
                        <MultiSelectCheckbox
                            onChange={(e) => {
                                setSelectedJobs(e.value)
                                dispatch(setPMJobs(e.value))
                            }}
                            value={selectedJobs}
                            option={rolesOptions}
                            placeholder="Disponibile a ricoprire mansione di..."
                            selectAllLabel="Tutte"
                        />
                    </div>
                    <div className="flex justify-end lg:min-w-[220px]">
                        <ButtonComponent
                            size="md"
                            iconPosition="off"
                            variant="solid"
                            color="orange"
                            label="Aggiungi requisito"
                            onClick={() => setAddPopupShow(true)}
                        />
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-3">
                {
                    requirementState.requirements.map(r =>
                        <ListItem
                            key={r.id}
                            code={Number(r.id)}
                            title={r.requirement}
                            numOfDetails={requirementState.requirementDetails
                                .filter(d => d.requirementId === r.id).length}
                            subTitle={r.norm}
                            paragraph={r.spec}
                            onEdit={() => handleOnEdit(r)}
                        />
                    )
                }
            </div>
            {
                addPopupShow && (
                    <PopupForm title="Nuovo requisito" close={() => {
                        dispatch(resetRequirementCreationRequest())
                        dispatch(resetRequirementErrors())
                        setAddPopupShow(false)
                    }}>
                        <RequirementPopupAdd close={() => setAddPopupShow(false)} />
                    </PopupForm>
                )
            }
            {
                editPopupShow && (
                    <PopupForm title="Modifica requisito" close={() => {
                        dispatch(resetRequirementUpdateRequest())
                        dispatch(resetRequirementErrors())
                        setEditPopupShow(false)
                    }}>
                        <RequirementPopupEdit close={() => setEditPopupShow(false)} />
                    </PopupForm>
                )
            }
        </div>
    )
}